import React, { useState, useRef } from 'react';
import { updateVersion } from '../api';
import Modal from './Modal';
import SqlEditor from './SqlEditor';
import ErrorBanner from './ErrorBanner';
import GradientButton from './GradientButton';
import GhostButton from './GhostButton';

export default function SqlEditModal({ version, queryId, onSave, onClose }) {
  const [sql, setSql]       = useState(version.sql_content);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const fileRef             = useRef(null);

  function handleFile(e) {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setSql(ev.target.result);
    reader.readAsText(file); e.target.value = '';
  }

  async function handleSave(e) {
    e.preventDefault();
    if (!sql.trim()) { setError('SQL content cannot be empty.'); return; }
    setSaving(true); setError('');
    try {
      await updateVersion(queryId, version.id, { sql_content: sql });
      onSave(); onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal title="Edit SQL" onClose={onClose} maxWidth="max-w-4xl">
      <form onSubmit={handleSave} className="space-y-4">
        <SqlEditor
          value={sql} onChange={e => setSql(e.target.value)}
          fileInputRef={fileRef} onFileUpload={handleFile}
          minRows={18}
        />
        <ErrorBanner message={error} />
        <div className="flex justify-end gap-3 pt-1">
          <GhostButton type="button" onClick={onClose}>Cancel</GhostButton>
          <GradientButton type="submit" disabled={saving}>
            {saving ? 'Saving…' : 'Save Changes'}
          </GradientButton>
        </div>
      </form>
    </Modal>
  );
}
